/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Card, TabContent, TabPane } from "reactstrap";
import { useContext, useEffect, useState } from "react";
import GuestProfileUserInfo from "./GuestProfileUserInfo";
import GuestProfileAutomationHistory from "./GuestProfileAutomationHistory";
import GuestProfileVisitHistory from "./GuestProfileVisitHistory";
import ActionButton from "../../elements/ActionButton";
import GuestProfileNavigation from "./GuestProfileNavigation";
import { requestGuestProfile } from "../../context/RequestManager";
import { AccountContext, ContextUpdater } from "../../context/ContextProvider";

export const GuestProfileTableLabel = ({id=null, faded = false, children}) => {
  const noData = children == null || children === "";
  return (
    <td id={id} className={`${faded || noData ? "text-muted fw-light" : ""} label-ellipsis`} style={{ maxWidth: "160px" }}>
      <span>{noData ? "-" : children}</span>
    </td>
  );
};

const GuestProfile = ({
  guestId,
  onDismiss,
}) => {
  // Context
  const accountContext = useContext(AccountContext);
  const updateContexts = useContext(ContextUpdater);

  // state
  const [currentTab, setCurrentTab] = useState("0");
  const guest = accountContext.guestProfile;

  useEffect(() => {
    if (guestId != null) {
      requestGuestProfile({
        context: updateContexts,
        token: accountContext.token,
        clientId: accountContext.clientId,
        guestId: guestId,
        completion: (response) => {
          // check for error
          if (response.error) {
            if (guest && guest.id !== guestId) {
              updateContexts({
                account: {
                  ...accountContext,
                  guestProfile: null
                }
              })
            }
            return;
          }
        } 
      });
    } else {
      updateContexts({
        account: {
          ...accountContext,
          guestProfile: null
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guestId])

  const handleDismiss = () => {
    onDismiss?.()
  }

  const navLinks = [
    { id: "0", name: "User Details"},
    { id: "1", name: "Marketing History"},
    { id: "2", name: "Visit History"}
  ];

  const props = {
    guest: guest
  }

  // styles
  const smoothTransitionStyle = {
    overflow: "hidden",
    transition: "all 0.6s ease-in-out"
  };

  return guest ? (
    <Card className= "ms-1 flex-40" style={smoothTransitionStyle}>
      <div className="w-100 p-2 d-flex justify-content-end">
        <ActionButton type="close" onClick={handleDismiss} />
      </div>
      <GuestProfileNavigation
        className="pt-3"
        guest={guest}
        navLinks={navLinks}
        selected={currentTab}
        onSelected={tab => setCurrentTab(tab)}
      />
      <div>
        <TabContent activeTab={currentTab}>
          <TabPane tabId="0">
            <GuestProfileUserInfo {...props}/>
          </TabPane>
          <TabPane tabId="1">
            <GuestProfileAutomationHistory {...props} />
          </TabPane>
          <TabPane tabId="2">
            <GuestProfileVisitHistory  {...props}/>
          </TabPane>
        </TabContent>
      </div>
    </Card>      
  ) : null;
}

export default GuestProfile;